/** Welcome/onboarding page — first-time learner greeting with onboarding completion CTA. */
import { useNavigate, useLocation } from 'react-router-dom';
import { motion } from 'motion/react';
import { useCompleteLearnerOnboarding } from '@/shared/api/hooks';
import { Button } from '@/interfaces/learner/ui';

const EASE = [0.16, 1, 0.3, 1] as const;

export default function WelcomePage() {
  const navigate = useNavigate();
  const location = useLocation();
  const completeOnboarding = useCompleteLearnerOnboarding();

  const intended = (location.state as { from?: string })?.from;

  function handleGetStarted() {
    completeOnboarding.mutate(undefined, {
      onSuccess: () => navigate(intended || '/', { replace: true }),
    });
  }

  return (
    <div
      className="flex min-h-screen flex-col items-center justify-center px-6"
      style={{
        background: 'var(--color-bg)',
        fontFamily: 'var(--font-sans)',
      }}
    >
      <motion.div
        className="relative text-center"
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: EASE }}
      >
        <h1
          className="text-section-title"
          style={{
            margin: 0,
          }}
        >
          Welcome to Formency
        </h1>

        <p
          className="text-body-muted mx-auto mt-4 max-w-md"
          style={{
            marginBottom: 0,
          }}
        >
          Your learning journey starts here. Explore courses, track your progress, and build
          knowledge at your own pace.
        </p>

        <div className="mt-8">
          <Button
            variant="accent"
            size="lg"
            onPress={handleGetStarted}
            isDisabled={completeOnboarding.isPending}
          >
            {completeOnboarding.isPending ? 'Getting started...' : 'Get started'}
          </Button>
        </div>
      </motion.div>
    </div>
  );
}
